// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2WW9j","info":"UpdateTermsInfo_info__24kMD"};